export default __webpack_public_path__ + "static/media/NotLogged.2a9d37c3.svg";